module.exports = __webpack_public_path__ + "static/media/rfmMainStandIn.dab3f765.png";